import axios, { type InternalAxiosRequestConfig } from 'axios'
import { getCookie } from 'cookies-next'

import { interceptErrorHandler } from '@core/helpers/errorHandler'
import { getAvivaServerUrl } from '@core/lib/api'
import { isBrowser } from '@core/lib/utils'

const avivaUserService = axios.create({
  baseURL: getAvivaServerUrl(undefined, 'user')
})

const avivaAppointmentService = axios.create({
  baseURL: getAvivaServerUrl(undefined, 'appointment')
})

const alimServer = axios.create({
  baseURL: process.env.NEXT_PUBLIC_ALIMDREAMS_SERVER ?? ''
})

// Espera a que el usuario regrese al app si la pantalla está apagada o cambió de app
const waitForPageVisible = (): Promise<void> =>
  new Promise(resolve => {
    if (typeof document === 'undefined' || !document.hidden) {
      resolve()
    } else {
      const handler = () => {
        if (!document.hidden) {
          document.removeEventListener('visibilitychange', handler)
          resolve()
        }
      }

      document.addEventListener('visibilitychange', handler)
    }
  })

avivaAppointmentService.interceptors.request.use(
  config => {
    // Get token from cookie if is browser and add to headers
    if (isBrowser) {
      const hasTokenHeader = config.headers.token
      if (hasTokenHeader) return config

      const access = getCookie('session')?.toString()
      if (access) config.headers.token = access
    }

    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

avivaUserService.interceptors.request.use(
  config => {
    // Get token from cookie if is browser and add to headers
    if (isBrowser) {
      const hasTokenHeader = config.headers.token
      if (hasTokenHeader) return config

      const access = getCookie('session')?.toString()
      if (access) config.headers.token = access
    }

    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

avivaUserService.interceptors.response.use(
  response => response,
  async error => {
    const config = error.config as InternalAxiosRequestConfig & { _retried?: boolean }

    if (error.code === 'ERR_NETWORK' && config && !config._retried) {
      config._retried = true
      await waitForPageVisible()
      await new Promise<void>(resolve => {
        setTimeout(resolve, 500)
      })

      return await avivaUserService(config)
    }

    interceptErrorHandler(error)

    return await Promise.reject(error)
  }
)

avivaAppointmentService.interceptors.response.use(
  response => response,
  async error => {
    const config = error.config as InternalAxiosRequestConfig & { _retried?: boolean }

    if (error.code === 'ERR_NETWORK' && config && !config._retried) {
      config._retried = true
      await waitForPageVisible()
      await new Promise<void>(resolve => {
        setTimeout(resolve, 500)
      })

      return await avivaAppointmentService(config)
    }

    interceptErrorHandler(error)

    return await Promise.reject(error)
  }
)
export { alimServer, avivaAppointmentService, avivaUserService }
